import { I18nService } from './i18n.service'
import i18nScopedData from './back-button.service.yml'

const i18nScoped = new I18nService(i18nScopedData)

function backButtonGetRecentHistory (storage: Storage) {
  return storage.getItem('recentHistoryV2')?.split('\\') || []
}

/**
 * Transforms an URL like http://localhost:5001/backoffice/castings/249142 into /backoffice/castings
 *
 * A "universe" is a group of pages arround the same object (typically, corresponding to an item in the main menu).
 */
export function backButtonGetUniverse (url: string) {
  return new URL(url).pathname.split('/').slice(0, 3).join('/')
}

/**
 * Transforms an index, or an URL of an object (show, edit or any sub path) into a label:
 * - http://localhost:5001/backoffice/customers => "Retour aux clients"
 * - http://localhost:5001/backoffice/customers/12 (or /12/edit, /12/documents...) => "Retour à la fiche client"
 *
 * Falls back to the generic "Retour" label for other URLs (ex. /new) and unknown resources.
 */
export function backButtonGetLabel (url: string) {
  const fallback = i18nScoped.t('back')
  const [, , resource, id] = new URL(url).pathname.replace(/\/$/, '').split('/')

  if (!resource) return fallback
  if (typeof id === 'undefined') return i18nScoped.t('index.' + resource, {}, fallback)
  if (/^\d+$/.test(id)) return i18nScoped.t('show.' + resource, {}, fallback)

  return fallback
}

export function backButtonStoreCurrentUrl (storage: Storage, currentLocation: string) {
  let recentHistory = backButtonGetRecentHistory(storage)

  // Reset recentHistory if currentLocation (excluding query and hash) is same than previous URL universe.
  // That would mean the users went back from a deep context to the main index.
  if (backButtonGetUniverse(currentLocation) === new URL(currentLocation).pathname) recentHistory = [currentLocation]
  else if (recentHistory[0] != currentLocation) recentHistory.unshift(currentLocation)

  storage.setItem('recentHistoryV2', recentHistory.slice(0, 30).join('\\'))
}

export function backButtonGetBackUrl (storage: Storage, universe: string, preferredBackUrl: string) {
  const urlsFromHistory = backButtonGetRecentHistory(storage).slice(1) // start from index 1 to exclude current location
  const urlsFromHistorySize = urlsFromHistory.length

  for (let i = 0; i < urlsFromHistorySize; i++) {
    const url = urlsFromHistory.shift()

    // Matched back URL: the mostrecent URL that is "equal" (with some approx.) to preferredBackUrl, or the source universe (ex. te customer those invoice ha been opened) in fallback
    if (backButtonGetUniverse(url) !== universe || new URL(url).pathname === new URL(preferredBackUrl).pathname) return url
  }

  return preferredBackUrl
}

export function backButtonNavigateBack (storage: Storage, backUrl: string, setCurrentLocation: (href: string) => void) {
  const urlsFromHistory = backButtonGetRecentHistory(storage).slice()
  const backUrlIndex = urlsFromHistory.indexOf(backUrl)

  // Forget navigations until the navigated by URL
  if (backUrlIndex > -1) storage.setItem('recentHistoryV2', urlsFromHistory.slice(backUrlIndex).join('\\'))
  else storage.removeItem('recentHistoryV2')
  setCurrentLocation(backUrl)
}